import Vue from 'vue';

// Domain
import { AllianzAccountIsOnCancellationProcessStateManager } from '../../domain/state/allianz-account-is-on-cancellation-process-state-manager';
import AllianzAccountIsOnCancellationProcessState from '../../domain/state/allianz-account-is-on-cancellation-process-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class AllianzAccountIsOnCancellationProcessVueStateManager implements
  AllianzAccountIsOnCancellationProcessStateManager {
  private _state: AllianzAccountIsOnCancellationProcessState = Vue.observable<
    AllianzAccountIsOnCancellationProcessState>(
      new AllianzAccountIsOnCancellationProcessState(),
    );

  private readonly observers: Observer[] = [];

  get state(): AllianzAccountIsOnCancellationProcessState {
    return this._state;
  }

  set state(value: AllianzAccountIsOnCancellationProcessState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<AllianzAccountIsOnCancellationProcessState>) {
    type Keys = keyof AllianzAccountIsOnCancellationProcessState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
